export default __webpack_public_path__ + "static/screen_teach-e2dbfbbde76877d40d74196b0b5e1c7a.png";